import stationsHeatmap from "./stationsHeatmap.component";
import stationsHeatmapUrls from "./stationsHeatmap.urls";
import StationsHeatmapTransforms from "./stationsHeatmap.transforms";

const stationsHeatmapModule = angular
  .module("app.components.stationsHeatmap", [])
  .component("stationsHeatmapPage", stationsHeatmap)
  .service("StationsHeatmapTransforms", StationsHeatmapTransforms)
  .config(stationsHeatmapUrls);

export default stationsHeatmapModule;



// WEBPACK FOOTER //
// ./src/pages/stationsHeatmap/stationsHeatmap.module.js